const PENDING_SERVICE_SETUP_OFFERING_ID_KEY = "bb-pending-service-setup-offering-id";
const PENDING_SERVICE_SETUP_OFFERING_SLUG_KEY = "bb-pending-service-setup-offering-slug";

export type PendingServiceSetupOpen = {
  offeringId: string | null;
  offeringSlug: string | null;
};

export function setPendingServiceSetupOffering(args: {
  offeringId?: string;
  offeringSlug?: string;
}): void {
  if (typeof window === "undefined") return;
  try {
    if (args.offeringId) {
      window.sessionStorage.setItem(PENDING_SERVICE_SETUP_OFFERING_ID_KEY, args.offeringId);
    } else {
      window.sessionStorage.removeItem(PENDING_SERVICE_SETUP_OFFERING_ID_KEY);
    }
    if (args.offeringSlug) {
      window.sessionStorage.setItem(PENDING_SERVICE_SETUP_OFFERING_SLUG_KEY, args.offeringSlug);
    } else {
      window.sessionStorage.removeItem(PENDING_SERVICE_SETUP_OFFERING_SLUG_KEY);
    }
  } catch {
    // sessionStorage may be unavailable
  }
}

export function consumePendingServiceSetupOffering(): PendingServiceSetupOpen {
  if (typeof window === "undefined") {
    return { offeringId: null, offeringSlug: null };
  }
  try {
    const offeringId = window.sessionStorage.getItem(PENDING_SERVICE_SETUP_OFFERING_ID_KEY);
    const offeringSlug = window.sessionStorage.getItem(PENDING_SERVICE_SETUP_OFFERING_SLUG_KEY);
    window.sessionStorage.removeItem(PENDING_SERVICE_SETUP_OFFERING_ID_KEY);
    window.sessionStorage.removeItem(PENDING_SERVICE_SETUP_OFFERING_SLUG_KEY);
    return { offeringId, offeringSlug };
  } catch {
    return { offeringId: null, offeringSlug: null };
  }
}

export function resolveServiceSetupOfferingId(
  offerings: Array<{ id: string; slug: string }>,
  pending: PendingServiceSetupOpen
): string | null {
  if (pending.offeringId && offerings.some((o) => o.id === pending.offeringId)) {
    return pending.offeringId;
  }
  if (pending.offeringSlug) {
    const match = offerings.find((o) => o.slug === pending.offeringSlug);
    if (match) return match.id;
  }
  return null;
}
